module.exports = __webpack_public_path__ + "img/don40-full.d62f16ea.png";